import { render, staticRenderFns } from "./OrthoShoulderTingling.vue?vue&type=template&id=028f7f6c&scoped=true"
import script from "./OrthoShoulderTingling.vue?vue&type=script&lang=js"
export * from "./OrthoShoulderTingling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f7f6c",
  null
  
)

export default component.exports